export type Predicate<T> = (value: T) => boolean;

export const truePredicate = () => true;
export const falsePredicate = () => false;

export type Action<T> = (value: T) => void;
export type Func<Args extends unknown[] = [], Return = undefined> = (...args: Args) => Return;
